module.exports = __webpack_public_path__ + "img/kavalan.0c6030af.jpg";